export default "__VITE_ASSET__4SmVF39h__"